import { getSubscriptionPlan } from "./subscriptionActions";
import { createNotification } from "../../utils/notificationManager";
import { isTruthyEnv } from "../../utils/paddleBilling";

const CLASSIC_PADDLE_SCRIPT_URL = "https://cdn.paddle.com/paddle/paddle.js";
let classicPaddleReady;

function loadClassicPaddleScript() {
  if (window.Paddle) {
    return Promise.resolve(window.Paddle);
  }

  if (classicPaddleReady) {
    return classicPaddleReady;
  }

  classicPaddleReady = new Promise((resolve, reject) => {
    const existingScript = document.querySelector(
      `script[src="${CLASSIC_PADDLE_SCRIPT_URL}"]`
    );

    if (existingScript) {
      existingScript.addEventListener("load", () => resolve(window.Paddle));
      existingScript.addEventListener("error", () =>
        reject(new Error("Unable to load Paddle Classic"))
      );
      return;
    }

    const script = document.createElement("script");
    script.src = CLASSIC_PADDLE_SCRIPT_URL;
    script.async = true;
    script.addEventListener("load", () => resolve(window.Paddle));
    script.addEventListener("error", () =>
      reject(new Error("Unable to load Paddle Classic"))
    );
    document.body.appendChild(script);
  });

  return classicPaddleReady;
}

export const initializePaddle = async (initiateAfterCheckoutLoader) => {
  const paddle = await loadClassicPaddleScript();
  if (!paddle) {
    return false;
  }

  if (isTruthyEnv(process.env.REACT_APP_DEBUG)) {
    paddle.Environment.set("sandbox");
  }

  paddle.Setup({
    vendor: parseInt(process.env.REACT_APP_PADDLE_VENDOR_ID, 10),
    eventCallback: (data) => {
      if (
        data?.event === "Checkout.Close" &&
        data.eventData?.checkout.completed
      ) {
        initiateAfterCheckoutLoader(data?.checkoutData);
      }
    },
  });

  return true;
};

export const openModal = (url) => {
  const paddle = window.Paddle;
  if (!paddle) {
    createNotification(
      "warning",
      "Paddle Classic is still loading. Please try again.",
      3000
    );
    return;
  }

  let doFetchPayment = true;
  getSubscriptionPlan(doFetchPayment);
  paddle.Checkout.open({
    override: url,
  });
};

export const paddleCheckout = (id, name, userMail) => {
  const paddle = window.Paddle;
  if (!paddle) {
    createNotification(
      "warning",
      "Paddle Classic is still loading. Please try again.",
      3000
    );
    return;
  }

  paddle.Checkout.open({
    method: "overlay", // set to `inline`
    product: parseInt(id), // replace with a product ID or plan ID
    allowQuantity: false,
    disableLogout: true,
    email: userMail,
    passthrough: {
      plan_name: name,
    },
  });
};
